import config from "./config.json"
import {createBrowserHistory} from "history"
import moment from "moment"
import {MainPage} from "./pages/MainPage"
import React from "react"
import {FolderPage} from "./pages/FolderPage"
import {AddCardBankPage} from "./pages/AddCardBankPage"
import {CreateFolderPage} from "./pages/CreateFolderPage"
import {CreateLinkPage} from "./pages/CreateLinkPage"
import {CreateNotePage} from "./pages/CreateNotePage"
import {FolderDetailPage} from "./pages/FolderDetailPage"
import {FolderSharePage} from "./pages/FolderSharePage"
import {GoogleDrivePage} from "./pages/GoogleDrivePage"
import {HelpWindowPage} from "./pages/HelpWindowPage"
import {LinkDetailPage} from "./pages/LinkDetailPage"
import {MainMoneyPage} from "./pages/MainMoneyPage"
import {MoneySettingsPage} from "./pages/MoneySettingsPage"
import {MonthDetailPage} from "./pages/MonthDetailPage"
import {NetPhonePage} from "./pages/NetPhonePage"
import {NoteDetailPage} from "./pages/NoteDetailPage"
import {NotePage} from "./pages/NotePage"
import {NoteSharePage} from "./pages/NoteSharePage"
import {PolicyPage} from "./pages/PolicyPage"
import {ProfilePage} from "./pages/ProfilePage"
import {UpdateCardBankPage} from "./pages/UpdateCardBankPage"
import {UpdateUserPage} from "./pages/UpdateUserPage"
import {UploadSingleImageFilePage} from "./pages/UploadSingleImageFilePage"
import {VerifyPage} from "./pages/VerifyPage"
import {YearDetailPage} from "./pages/YearDetailPage"
import {YearMoneyPage} from "./pages/YearMoneyPage"
import {AddCashTo} from "./pages/AddCashTo"
import {CheckingCollectionsPage} from "./pages/CheckingCollectionsPage"
import {CloudinaryUploadImagePage} from "./pages/CloudinaryUploadImagePage"

const $ = require("jquery")
const dayNum = 86400000
const year = new Date().getFullYear()
const month = new Date().getMonth()
const date = new Date().getDate()
const zeroNumber = new Date(year, month, date, 0, 0, 0)
const host = window.location.host === 'localhost:3000' ? config.localHost : config.onrender

export const setErrorWindow = (
    title,
    code,
    desc,
    btnOK,
    clickOK,
    btnCancel,
    clickCancel,
    btnOKColor = 'danger',
    btnCancelColor = 'secondary') => {

    const lang = objectLang().language
    const l = lang.lang

    let pathBack = getPathBack()
    if (!pathBack) {
        pathBack = `/${l}/`
    }
    if (!desc && !code) {
        desc = lang.messages[`code_${999}`]
    }
    if (!desc && code) {
        desc = lang.messages[`code_${code}`]
    }
    if (!btnOK) {
        btnOK = lang.modal.errors.btnOK
    }
    if (!btnCancel) {
        btnCancel = lang.modal.errors.btnCancel
    }
    if (!clickOK) {
        clickOK = 'reload'
    }
    if (!clickCancel) {
        clickCancel = `replaceTo ${pathBack}`
    }
    if (!title) {
        title = lang.modal.errors.title
    }
    if (clickOK === 'replaceToBack') {
        btnOK = lang.modal.buttons.btnToBack
    }
    if (clickOK === 'replaceToMain') {
        btnOK = lang.modal.buttons.btnToMain
    }
    if (clickOK === 'replaceToAuth') {
        btnOK = lang.modal.buttons.btnToAuth
    }

    let dataModal = {
        title: title,
        desc: desc,
        btnCancel: btnCancel,
        btnOK: btnOK,
        clickOK: clickOK,
        clickCancel: clickCancel,
        btnOKColor: btnOKColor,
        btnCancelColor: btnCancelColor
    }
    if (code === 0 || code === 604 || code === 609 || code === 613 || code === 614 || code === 615 || code === 6014) {
        setLocalStorageItem('dataModal', dataModal)
        return dataModal
    }
    if (code === 6042) {
        dataModal.title = lang.modal.errors.title
        dataModal.desc = lang.messages.code_6042
        dataModal.btnCancel = lang.modal.errors.btnCancel
        dataModal.btnOK = lang.modal.errors.btnAuth
        dataModal.clickOK = 'replaceToAuthAndDeleteCookies'
        dataModal.clickCancel = 'replaceToMainAndDeleteCookies'
        setLocalStorageItem('dataModal', dataModal)
        return dataModal
    }
    setLocalStorageItem('dataModal', dataModal)
    return dataModal
}

export const setDataModalFromCatch = (e) => {
    console.error(e.message)
    const lang = objectLang().language
    const l = lang.lang
    return setErrorWindow(
        lang.modal.errors.title,
        '',
        lang.messages.code_999,
        '',
        'replaceToMainAndDeleteCookies',
        '',
        `replaceTo /${l}/`
    )
}

export const getAuthHeader = (auth) => {
    return `Bearer ${auth.accessToken} DeviceId ${auth.deviceId} Authenticated ${auth.authenticatedVia}`
}

export const refreshAT = async (auth, request) => {
    const l = objectLang().language.lang
    try {
        const data = await request(
            `${host}/api/user/refresh`,
            'GET',
            null,
            {
                'Content-Type': 'application/json',
                Authorization: getAuthHeader(auth)
            })
        if (data.status > 200) {
            auth.logout()
            window.location.replace(`/${l}/`)
        } else {
            auth.login(
                data.superUser,
                data.rootFolder,
                data.avatarLink,
                data.accessToken,
                data.refreshToken,
                data.userId,
                data.nickName,
                data.language,
                data.authenticatedVia,
                data.deviceId
            )
            const page = getLocalStorageItem('page')
            switch (page) {
                case 'MainPage':
                    return (<MainPage />)
                case 'AddCardBankPage':
                    return (<AddCardBankPage />)
                case 'AddCashTo':
                    return (<AddCashTo />)
                case 'CreateFolderPage':
                    return (<CreateFolderPage />)
                case 'CreateLinkPage':
                    return (<CreateLinkPage />)
                case 'CreateNotePage':
                    return (<CreateNotePage />)
                case 'FolderDetailPage':
                    return (<FolderDetailPage />)
                case 'FolderPage':
                    return (<FolderPage/>)
                case 'FolderSharePage':
                    return (<FolderSharePage />)
                case 'GoogleDrivePage':
                    return (<GoogleDrivePage />)
                case 'HelpWindowPage':
                    return (<HelpWindowPage />)
                case 'LinkDetailPage':
                    return (<LinkDetailPage />)
                case 'MainMoneyPage':
                    return (<MainMoneyPage />)
                case 'MoneySettingsPage':
                    return (<MoneySettingsPage />)
                case 'MonthDetailPage':
                    return (<MonthDetailPage />)
                case 'NetPhonePage':
                    return (<NetPhonePage />)
                case 'NoteDetailPage':
                    return (<NoteDetailPage />)
                case 'NotePage':
                    return (<NotePage />)
                case 'NoteSharePage':
                    return (<NoteSharePage />)
                case 'PolicyPage':
                    return (<PolicyPage />)
                case 'ProfilePage':
                    return (<ProfilePage />)
                case 'UpdateCardBankPage':
                    return (<UpdateCardBankPage />)
                case 'UpdateUserPage':
                    return (<UpdateUserPage />)
                case 'UploadSingleImageFilePage':
                    return (<UploadSingleImageFilePage />)
                case 'CloudinaryUploadImagePage':
                    return (<CloudinaryUploadImagePage />)
                case 'VerifyPage':
                    return (<VerifyPage />)
                case 'YearDetailPage':
                    return (<YearDetailPage />)
                case 'YearMoneyPage':
                    return (<YearMoneyPage />)
                case 'CheckingCollectionsPage':
                    return (<CheckingCollectionsPage />)

                default:
                    window.location.replace(`/${l}`)
            }
        }
    } catch (e) {
        window.location.replace(`/${l}/`)
    }
}

export const formatDate = (dateStr) => {
    if (isString(dateStr)) {
        const date = dateStr.split('T')[0]
        const arrDate = date.split('-')
        const year = arrDate[0]
        const month = arrDate[1]
        const day = arrDate[2]
        const timeWithSec = dateStr.split('T')[1].split('.')[0]
        const time = timeWithSec.split(':')[0] + ':' + timeWithSec.split(':')[1]
        return {date: day + '.' + month + '.' + year, time: time}
    }
    return ''
}

export const getDomain = (str) => {
    let res = 'default'
    if (!str) return res
    const regexp = /^(?:[^:]+:\/\/)?([^./?#]+\.)*([^./?#]+)\.([^./?#]+)(?:$|[/?#])/
    if (str.match(regexp)) {
        res = str.match(regexp)[2]
    }
    return res
}

export const getLink = (str) => {
    let res = 'https://us-link.cloud'
    if (str) {
        if (str.includes("http")) {
            if (str.split("http").length >= 2) {
                res = `http${str.split("http")[1]}`
            }
        }
    }
    return res
}

export const getIcon = (linkFrom, defaultLink) => {
    const usLink_logo = require("./images/us-link-icon-500.png")
    const booking_logo = require("./images/booking-logo-2.png")
    const google_logo = require("./images/linkGoogle.png")
    const google_disk_logo = require("./images/google-disc-logo.png")
    const yandex_disk_logo = require("./images/yandex-disk.png")
    const docs_logo = require("./images/microsoft-word-logo.png")
    const sheets_logo = require("./images/microsoft-sheets-logo.png")
    const presentation_logo = require("./images/microsoft-presentation-logo.png")
    const classroom_logo = require("./images/google-classroom-logo.png")
    const airplane_logo = require("./images/airplane.jpg")
    const waze_logo = require("./images/waze-logo.png")
    const phone_logo = require("./images/phone-logo.jpg")
    const mail_logo = require("./images/mail-logo.png")
    const yandex_logo = require("./images/yandex-logo.png")
    const avito_logo = require("./images/avito-logo.png")
    const zoom_logo = require("./images/zoom-logo.png")
    const hapoalim_logo = require("./images/hapoalim-logo.png")
    const disney_logo = require("./images/disneyland-Logo.png")
    const gosuslugi_logo = require("./images/gosuslugi-logo.png")
    const fns_logo = require("./images/fns-logo.png")
    const aliexpress_logo = require("./images/aliexpress-logo.png")
    const meet_logo = require("./images/meet-logo.png")
    const youtube_logo = require("./images/youtube-logo.png")
    const netflix_logo = require("./images/netflix-logo.png")
    const ok_logo = require("./images/ok-logo.png")
    const vk_logo = require("./images/vk-logo.png")
    const facebook_logo = require("./images/facebook-logo.png")
    const video_logo = require("./images/video-logo.png")
    const acrobat_logo = require("./images/acrobat-logo.png")
    const google_map_logo = require("./images/google-map-logo.png")
    const google_mail_icon_logo = require("./images/gmail-logo-512.png")
    const google_map_icon_logo = require("./images/google-map-icon-logo.png")
    const instagram_logo = require("./images/instagram-logo.png")
    const paypal_logo = require("./images/paypal-logo.jpg")
    const super_pharm_logo = require("./images/supr-pharm-logo.png")
    const apartment_logo = require("./images/apartment-logo.jpg")
    const book_logo = require("./images/book-logo.png")
    const get_course_logo = require("./images/get-course-logo.png")
    const weezmo_logo = require("./images/weezmo-logo.jpg")
    const sberbank_logo = require("./images/sberbank-logo.png")
    const maccabi = require("./images/maccabi.png")
    const maccabi_dent = require("./images/maccabi-dent.png")
    const speedtest_logo = require("./images/speedtest-logo.png")
    const foods_logo = require("./images/foods-logo.png")
    const israel_post_logo = require("./images/doar-israel-logo.png")
    const image_file_logo = require("./images/image-icon.png")
    const ntv_logo = require("./images/ntv_logo.png")
    const one_tv_logo = require("./images/one-tv-logo.png")
    const eye_tv_logo = require("./images/eye-tv-logo.png")
    const smotrim_logo = require("./images/smotrim-logo.png")
    const audio_logo = require("./images/audio-logo.png")
    const android_apk_logo = require("./images/android-apk-logo-2.png")
    const install_desktop_logo = require("./images/Install-desktop-logo.png")
    const pdf_drive_logo = require("./images/pdf-drive-logo.png")
    const archive_drive_logo = require("./images/archive-drive-logo.png")
    const instrument_calc_logo = require("./images/calc-logo-512.png")

    let domain = ''
    let split_HTTPS = linkFrom.split('https://')[1]
    let split_WWW = linkFrom.split('www.')[1]
    let split_slash = split_HTTPS
    if (split_HTTPS) {
        if (split_HTTPS.includes('/')) {
            split_slash = split_HTTPS.split('/')[0]
        } else {
            split_slash = split_HTTPS
        }
        domain = getDomain(split_slash)
    } else if (split_WWW) {
        if (split_WWW.includes('/')) {
            split_slash = split_WWW.split('/')[0]
        } else {
            split_slash = split_WWW
        }
        domain = getDomain(split_slash)
    } else {
        domain = 'default'
    }
    if (domain === 'co') {
        let il = linkFrom.split('co.')[1]
        let il_slash
        if (il) {
            il_slash = il.split('/')[0]
        } else {
            domain = 'default'
        }
        if (il_slash === 'il') {
            domain = getDomain(linkFrom.split('.il')[0])
        } else {
            domain = 'default'
        }
    }

    if (domain === 'google') {
        const googleLinkStart = linkFrom.split('google')[0]
        const googleLinkAfterStart = linkFrom.split('google')[1]
        if (googleLinkStart.includes('docs')) {
            if (linkFrom.split('google').length > 0) {
                const path = linkFrom.split('google')[1]
                if (path.includes('spreadsheets')) {
                    domain = 'spreadsheets'
                } else if (path.includes('document')) {
                    domain = 'docs'
                } else if (path.includes('presentation')) {
                    domain = 'presentation'
                } else {
                    domain = 'google'
                }
            }
        } else if (googleLinkStart.includes('drive')) {
            if (linkFrom.split('google').length > 0) {
                const path = linkFrom.split('google')[1]
                if (path.includes('file')) {
                    domain = 'google-file'
                } else {
                    domain = 'google'
                }
            }
        } else {
            if (googleLinkAfterStart.includes('maps')) {
                domain = 'maps'
            } else if (googleLinkAfterStart.includes('.com/mail')) {
                domain = 'google-mail'
            } else {
                domain = 'google'
            }
        }
    }

    if (domain === 'googleusercontent') {
        if (linkFrom.split('googleusercontent').length > 1) {
            const link = linkFrom.split('googleusercontent')[1]
            if (link.includes('audio')) {
                domain = 'audio'
            } else if (link.includes('x-msdownload')) {
                domain = 'desktop-exe'
            } else if (link.includes('android')) {
                domain = 'android-apk'
            } else if (link.includes('pdf')) {
                domain = 'pdf-drive'
            } else if (link.includes('compressed')) {
                domain = 'compressed'
            } else {
                domain = 'file'
            }
        }
    }

    if (domain === 'yandex') {
        let disk = linkFrom.split('yandex')[0]
        if (disk.includes('disk')) {
            domain = 'disk'
        } else {
            domain = 'yandex'
        }
    }

    if (domain === 'cloudinary') {
        let after = linkFrom.split('cloudinary')[0]
        if (after.includes('res')) {
            domain = 'cloudinary'
        } else {
            domain = 'default'
        }
    }

    if (domain === 'web') {
        let after = linkFrom.split('web')[0]
        if (after.includes('instrument-calc')) {
            domain = 'calc'
        } else {
            domain = 'default'
        }
    }

    switch (domain) {
        case 'us-link':
            return usLink_logo
        case 'google':
            return google_logo
        case 'compressed':
            return archive_drive_logo
        case 'passwords':
            return google_logo
        case 'audio':
            return audio_logo
        case 'drive':
            return google_disk_logo
        case 'disk':
            return yandex_disk_logo
        case 'yandex':
            return yandex_logo
        case 'docs':
            return docs_logo
        case 'spreadsheets':
            return sheets_logo
        case 'presentation':
            return presentation_logo
        case 'google-file':
            return google_disk_logo
        case 'classroom':
            return classroom_logo
        case 'wizzair':
            return airplane_logo
        case 'easyjet':
            return airplane_logo
        case 'elal':
            return airplane_logo
        case 'elal-mail':
            return airplane_logo
        case 'matmid':
            return airplane_logo
        case 'aeroflot':
            return airplane_logo
        case 's7':
            return airplane_logo
        case 'uralairlines':
            return airplane_logo
        case 'egyptair':
            return airplane_logo
        case 'aa':
            return airplane_logo
        case 'turkishairlines':
            return airplane_logo
        case 'pobeda':
            return airplane_logo
        case 'azimuth':
            return airplane_logo
        case 'waze':
            return waze_logo
        case 'booking':
            return booking_logo
        case 'golantelecom':
            return phone_logo
        case 'tele2':
            return phone_logo
        case 'mail':
            return mail_logo
        case 'avito':
            return avito_logo
        case 'edu-il':
            return zoom_logo
        case 'zoom':
            return zoom_logo
        case 'us04web':
            return zoom_logo
        case 'bankhapoalim':
            return hapoalim_logo
        case 'disneylandparis':
            return disney_logo
        case 'disneyland':
            return disney_logo
        case 'gosuslugi':
            return gosuslugi_logo
        case 'nalog':
            return fns_logo
        case 'aliexpress':
            return aliexpress_logo
        case 'meet':
            return meet_logo
        case 'youtube':
            return youtube_logo
        case 'youtu':
            return youtube_logo
        case 'netflix':
            return netflix_logo
        case 'ok':
            return ok_logo
        case 'vk':
            return vk_logo
        case '1tv':
            return one_tv_logo
        case 'ntv':
            return ntv_logo
        case 'glaz':
            return eye_tv_logo
        case 'smotrim':
            return smotrim_logo
        case 'facebook':
            return facebook_logo
        case 'kinovasek':
            return video_logo
        case 'kinosimka4':
            return video_logo
        case 'kinovibe':
            return video_logo
        case 'kinotut':
            return video_logo
        case 'rezka':
            return video_logo
        case 'hdrezka':
            return video_logo
        case 'rezka-ua':
            return video_logo
        case 'inoriginal':
            return video_logo
        case 'kinokrad':
            return video_logo
        case 'kinogohd':
            return video_logo
        case 'kinogo':
            return video_logo
        case 'zagonkop.db':
            return video_logo
        case 'anwap':
            return video_logo
        case 'kinonadzor':
            return video_logo
        case 'kinozapas':
            return video_logo
        case 'kinogo1':
            return video_logo
        case 'filmix':
            return video_logo
        case 'rserial':
            return video_logo
        case 'ivi':
            return video_logo
        case 'adobe':
            return acrobat_logo
        case 'goo':
            return google_map_logo
        case 'maps':
            return google_map_icon_logo
        case 'google-mail':
            return google_mail_icon_logo
        case 'instagram':
            return instagram_logo
        case 'paypal':
            return paypal_logo
        case 'super-pharm':
            return super_pharm_logo
        case 'myresidhome':
            return apartment_logo
        case 'isradon':
            return book_logo
        case 'alfavit':
            return book_logo
        case 'siman-kria':
            return book_logo
        case 'ok-mozg':
            return get_course_logo
        case 'volkovaforwomen':
            return get_course_logo
        case 'weezmo':
            return weezmo_logo
        case 'sberbank':
            return sberbank_logo
        case 'maccabi4u':
            return maccabi
        case 'maccabi-dent':
            return maccabi_dent
        case 'speedtest':
            return speedtest_logo
        case 'eda':
            return foods_logo
        case 'gotovim-doma':
            return foods_logo
        case 'yasensvit':
            return foods_logo
        case 'koolinar':
            return foods_logo
        case 'delo-vcusa':
            return foods_logo
        case 'vkusnyblog':
            return foods_logo
        case '1000':
            return foods_logo
        case 'baking-academy':
            return foods_logo
        case 'israelpost':
            return israel_post_logo
        case 'cloudinary':
            return image_file_logo
        case 'flyredwings':
            return airplane_logo
        case 'android-apk':
            return android_apk_logo
        case 'desktop-exe':
            return install_desktop_logo
        case 'pdf-drive':
            return pdf_drive_logo
        case 'calc':
            return instrument_calc_logo
        default:
            return defaultLink
    }
}

export const isValidUrl = (str) => {
    try {
        new URL(str)
        return true
    } catch {
        return false
    }
}

export const getThumbUrlOfExt = (url) => {
    const defaultLogo = require("./images/link-logo-default.png")
    const pdf = require("./images/acrobat-logo.png")
    const audio = require("./images/audio-logo.png")
    const image = require("./images/image-icon.png")
    const video = require("./images/video-logo.png")

    const lower = url.toLowerCase()

    const patterns = {
        pdf: /\.pdf(\?|#|$)/,
        audio: /\.(mp3|wav|ogg|flac|m4a|aac|wma)(\?|#|$)/,
        video: /\.(mp4|mov|avi|mkv|webm|flv|wmv|mpeg|mpg)(\?|#|$)/,
        image: /\.(png|jpg|jpeg|gif|bmp|webp|tiff|svg)(\?|#|$)/
    }

    if (patterns.pdf.test(lower)) return pdf
    if (patterns.audio.test(lower)) return audio
    if (patterns.video.test(lower)) return video
    if (patterns.image.test(lower)) return image

    return defaultLogo
}

export const objectLang = () => { // Return object {languages, language}
    let languages, language
    if (getLocalStorageItem('languages')) {
        languages = getLocalStorageItem('languages')
    } else {
        languages = {
            en: {
                lang: 'en',
                navbar: {
                    isAuth: {
                        title: '',
                        btnAdmin: 'Admin',
                        linkAdmin: '/en/admin',
                        btnMyLinks: 'My Links',
                        linkMyLinks: '/en/my-links',
                        btnMoney: 'Money',
                        linkCash: '/en/money',
                        btnPublicLinks: 'Public Links',
                        linkPublicLinks: `/en/folder/open-public/${config.trialRootFolderId}`,
                        btnProfile: 'Profile',
                        linkProfile: `/en/profile`,
                        placeholderSearch: 'Search...',
                        btnSearch: 'Search',
                        linkSearch: '/en/search',
                        btnOut: 'Exit',
                        linkOut: '/en/exit',
                        btnUpdateLang: 'Update Language',
                        linkUpdateLang: '/en/update-lang',
                        askHelp: 'Help',
                        linkAskHelp: '/en/ask-help',
                        btnNetphone: 'Net-phone',
                        linkNetphone: '/en/net-phone',
                        btnGoogleDrive: 'Google drive',
                        linkGoogleDrive: '/en/google-drive/open/root',
                        btnGoogleMail: 'Gmail',
                        linkGoogleMail: 'https://accounts.google.com/AccountChooser?service=mail&continue=https://mail.google.com/mail/',
                    },
                    isNotAuth: {
                        title: 'Us-Link',
                        btnAuth: 'Login',
                        linkAuth: '/en/auth-form',
                        btnRegister: 'Register',
                        linkRegister: '/en/register',
                        placeholderSearch: 'Search...',
                        btnSearch: 'Search',
                        linkSearch: '/en/search',
                        btnPublicLinks: 'Public Links',
                        linkPublicLinks: `/en/folder/open-public/${config.trialRootFolderId}`,
                    },
                    toHome: "Main page",
                    linkToHome: '/en/',
                    optionalsLanguage: {
                        ru: 'Russian',
                        en: 'English',
                        fr: 'French',
                        he: 'Hebrew',
                        de: 'German',
                        ar: 'Arabic'
                    },
                },
                body: {
                    welcome: {
                        h1_0: 'Welcome!',
                        p1_0: 'This site is your personal storage for internet links.',
                        p1_1: 'No ads — just you and your discoveries, neatly organized into folders like in Windows Explorer.',
                        p2_0: 'Forgot where you saw that great shop, article or movie? Save it here — and never lose it again.',
                        p2_1: 'I use it every day myself — I’ve already saved over a thousand links.',
                        p3_0: 'Join in — it might turn out handy for you too.',
                        p3_1: 'Spotted an error or have an idea? Drop a line at ',
                        a1_href: 'mailto:using.links.mail@gmail.com',
                        a1_0: 'using.links.mail@gmail.com',
                    },
                    general: {
                        btnBack: 'Back',
                        btnToHomePage: 'To Home Page',
                    },
                    contextMenu: {
                        auth: 'Login',
                        moveToFolder: 'Cut',
                        copyToFolder: 'Copy',
                        updateItem: 'Change',
                        openItem: 'Open',
                        createNewFolder: 'Create\u00A0a\u00A0new\u00A0folder',
                        createNewLink: 'Create\u00A0a\u00A0new\u00A0link',
                        createNewNote: 'Create\u00A0a\u00A0new\u00A0note',
                        propertiesItem: 'Properties',
                        deleteItem: 'Delete',
                        pasteFolder: 'Paste\u00A0folder',
                        pasteLink: 'Paste\u00A0link',
                        pasteNote: 'Paste\u00A0note',
                        clearBuffer: 'Clear\u00A0buffer',
                        uploadFile: 'upload\u00A0new\u00A0file',
                        uploadImages: 'upload images',
                        share: 'Share',
                        noShare: 'Stop sharing',
                        rename: 'Rename'
                    },
                    authPage: {
                        title: 'Authorization page',
                        titleButton: 'Fill out the form',
                        buttonSocial: 'Socials',
                        labelEmail: 'Email ',
                        placeholderEmail: 'Tap email',
                        labelPassword: 'Password ',
                        placeholderPassword: 'Tap password ',
                        btnLogin: 'Sign in',
                        btnRemindPass: 'Restore password',
                        codeVerify: 'Verification code',
                        tapeCode: 'Enter code from email',
                        getCodeAgain: 'Get code again',
                        inToAnotherAccount: 'Sign in to another account',
                        restorePassword: 'Restore password'
                    },
                    restorePage: {
                        title: 'Restore access',
                        labelEmail: 'Email ',
                        placeholderEmail: 'Tap Email',
                        btnSend: 'Send',
                    },
                    changePasswordPage: {
                        title: 'Enter your new password here',
                        labelPassword: 'Password',
                        placeholderPassword: 'Tap password',
                        btnSend: 'Send',
                    },
                    registerPage: {
                        title: 'Register page',
                        titleButton: 'Fill out the form',
                        buttonSocial: 'Socials',
                        labelEmail: 'Email (required)',
                        placeholderEmail: 'Tap email',
                        labelPhone: 'Phone (required)',
                        placeholderPhone: 'Tap phone',
                        labelFirstName: 'First name (required)',
                        placeholderFirstName: 'Tap first name',
                        labelLastName: 'Last name',
                        placeholderLastName: 'Tap last name',
                        labelNickName: 'Nick (required)',
                        placeholderNickName: 'Tap nick',
                        labelLanguage: 'Default language',
                        optionalsLanguage: {
                            ru: 'Russian',
                            en: 'English',
                            fr: 'French',
                            he: 'Hebrew',
                            de: 'German',
                            ar: 'Arabic'
                        },
                        labelCountry: 'Counter',
                        optionalsCountry: {russia: 'Russia', usa: 'USA', israel: 'Israel', germany: 'Germany'},
                        labelPasswordOne: 'Password (required)',
                        placeholderPasswordOne: 'Create a password',
                        labelPasswordTwo: 'Repeat password (required)',
                        placeholderPasswordTwo: 'Repeat password',
                        labelCheckBox: 'Send SMS on login',
                        btnRegister: 'Create Account',
                        btnRegisterGoogle: 'Sign up via Google',
                        labelCodeVerify: 'Verification code (required)',
                        placeholderCodeVerify: 'Tap verification code',
                        sendCodeVerify: 'Send code',
                    },
                    verifyPage: {
                        title: 'Verification',
                        description: 'Check your email, an email with a verification code has been sent to you. It must be entered in this field to complete the registration process.',
                        label: 'Verification code',
                        codePlaceholder: 'Enter verification code from email',
                        btnSendCode: 'Send',
                        btnSendCodeAgain: 'Get the code again',
                        btnBack: 'Back'
                    },
                    sharedPage: {
                        title: 'Shared access',
                    },
                    googleDrivePage: {
                        googleUploadFile: {
                            title: 'Uploading files to Google Drive',
                            loadHere: 'We load here',
                            selectFiles: 'Select files',
                            fileIsLoading: 'The file is loading',
                            of: 'of',
                            upload: 'Upload',
                            success: 'File(s) uploaded',
                            rootFolder: 'Root folder',
                        },
                        title: 'Google Drive',
                        googlePhoto: 'Google Photo',
                        trash: 'Trash',
                        foldersAndFiles: 'Folders and files',
                        clearTrash: 'Clear trash'
                    },
                    googlePropertiesPage: {
                        title: 'Properties',
                        created: 'Created',
                        modified: 'Modified',
                        items: 'Items',
                        totalSize: 'Total size',
                        owners: 'Owners',
                        openInDrive: 'Open in Drive',
                        folder: 'Folder',
                    },
                    googleRenamePage: {
                        title: 'Rename',
                        newName: 'New name',
                        send: 'Send',
                    },
                    folderRenamePage: {
                        title: 'Rename',
                        newName: 'New name',
                        send: 'Send',
                    },
                    noteRenamePage: {
                        title: 'Rename',
                        newName: 'New name',
                        send: 'Send',
                    },
                    linkRenamePage: {
                        title: 'Rename',
                        newName: 'New name',
                        send: 'Send',
                    },
                    profilePage: {
                        title: 'My profile',
                        firstName: 'First name',
                        firstNameLabel: 'First name',
                        firstNamePlaceholder: 'First name',
                        lastName: 'Last name',
                        lastNameLabel: 'Last name',
                        lastNamePlaceholder: 'Last name',
                        nickName: 'Nick',
                        nickNameLabel: 'Nick',
                        nickNamePlaceholder: 'Nick',
                        email: 'Email',
                        emailLabel: 'Email',
                        emailPlaceholder: 'Email',
                        passwordOld: 'Password old',
                        passwordOldLabel: 'Password old',
                        passwordOldPlaceholder: 'Password old',
                        passwordNew: 'Password new',
                        passwordNewLabel: 'Password new',
                        passwordNewPlaceholder: 'Password new',
                        passwordRepeat: 'Repeat password',
                        passwordRepeatLabel: 'Repeat password',
                        passwordRepeatPlaceholder: 'Repeat password',
                        verify: 'Verify',
                        isActivated: 'Activated',
                        dateRegister: 'Date of registration',
                        phoneNumber: 'Phone',
                        phoneNumberLabel: 'Phone',
                        phoneNumberPlaceholder: 'Phone',
                        country: 'Country',
                        countryLabel: 'Country',
                        language: 'Language',
                        languageLabel: 'Language',
                        languagePlaceholder: 'Language',
                        avatar: 'Avatar',
                        about: 'About me',
                        aboutLabel: 'About me',
                        aboutPlaceholder: 'About me',
                        authWithSms: 'Send SMS at login',
                        updateProfile: 'Update profile',
                        cancelUpdateProfile: 'Cancel changes',
                        deleteAccountBtn: 'Delete account',
                        saveProfileBtn: 'Save',
                    },
                    linksPage: {
                        title: 'My links',
                        buttonDetail: 'Details',
                        btnCreateLink: 'New link',
                    },
                    linkPage: {
                        windowRequestIfSave: {
                            titleUpdate: 'Link properties have been changed!',
                            descriptionUpdate: 'Do you want to save before closing?',
                            btnOKUpdate: 'Save',
                            btnCancelUpdate: 'Don\'t save'
                        },
                        owner: 'Link owner',
                        createdDate: 'Created date:',
                        lastEntrance: 'Last entrance:',
                        numberOfClicks: 'Number of clicks:',
                        labelSiteLink: 'Site Link',
                        labelSiteTitle: 'Name of the site',
                        labelSiteDescription: 'Description of the site',
                        labelLoginSite: 'Login of the site',
                        labelPasswordSite: 'Password of the site',
                        placeholderSiteLink: 'Enter site link',
                        placeholderSiteTitle: 'Enter name of the site',
                        placeholderSiteDescription: 'Enter description of the site',
                        placeholderLoginSite: 'Enter login of the site',
                        placeholderPasswordSite: 'Enter password of the site',
                        buttonBack: 'Back',
                        buttonSave: 'Save',
                        buttonUpdate: 'Update',
                        buttonDelete: 'Delete',
                        isShare: 'Share link',
                        accessLink: 'Public link',
                        openInNewTab: 'Open in a new tab',
                        linkCopied: 'Link copied',
                    },
                    folderPage: {
                        windowRequestIfSave: {
                            titleUpdate: 'Folder properties have been changed!',
                            descriptionUpdate: 'Do you want to save before closing?',
                            btnOKUpdate: 'Save',
                            btnCancelUpdate: 'Don\'t save'
                        },
                        owner: 'Folder owner',
                        createdDate: 'Created date:',
                        lastEntrance: 'Last entrance:',
                        labelName: 'Name',
                        placeholderName: 'Enter a name for the folder',
                        labelDescription: 'Description',
                        placeholderDescription: 'Enter a description for the folder',
                        buttonBack: 'Back',
                        buttonSave: 'Save',
                        buttonUpdate: 'Update',
                        buttonDelete: 'Delete',
                        isShare: 'Share link',
                        accessLink: 'Public link',
                        openInNewTab: 'Open in a new tab',
                        linkCopied: 'Link copied',
                    },
                    notePage: {
                        windowRequestIfSave: {
                            titleUpdate: 'The note has been changed!',
                            titleCreate: 'The new note has not been saved yet!',
                            descriptionUpdate: 'Do you want to save it before closing?',
                            descriptionCreate: 'Do you want to save it before closing?',
                            btnOKUpdate: 'Save',
                            btnOKCreate: 'Save',
                            btnOKTapeName: 'Enter name',
                            btnCancelUpdate: 'Cancel',
                            btnCancelCreate: 'Cancel'
                        },
                        title: 'Note',
                        createdDate: 'Created date:',
                        lastEntrance: 'Last entrance:',
                        numberOfClicks: 'Number of clicks:',
                        labelNoteTitle: 'Name of note',
                        placeholderNoteTitle: 'Enter note name',
                        labelNoteBody: 'Text of note',
                        placeholderNoteBody: 'Enter note text',
                        buttonBack: 'Back',
                        buttonSave: 'Save',
                        buttonOpen: 'Open',
                        buttonDelete: 'Delete',
                        isShare: 'Share link',
                        accessLink: 'Public link'
                    },
                    createFolderPage: {
                        title: 'Create new folder',
                        placeholderName: 'Enter a name for the folder',
                        btnCreateFolder: 'Create folder',
                    },
                    createLinkPage: {
                        title: 'Create new link',
                        placeholderName: 'Enter a name for the link',
                        placeholderDesc: 'Enter a site description',
                        placeholderLink: 'Enter site link',
                        btnCreateLink: 'Create link',
                    },
                    createNotePage: {
                        title: 'Create new note',
                        placeholderName: 'Type a name for the note',
                        placeholderText: 'Type your note text',
                        btnCreateNote: 'Create note',
                        btnSaveNote: 'Save',
                        btnPropertiesNote: 'Properties',
                    },
                    myLinksPage: {
                        title: 'My Links',
                        titlePublicLinks: 'Public Links',
                    },
                    foldersPage: {
                        title: 'My folders',
                        btnOpenFolder: 'Open',
                        btnCreateFolder: 'New folder',
                        upToLevel: 'Up a level',
                        filterName: 'Filter',
                        filterPlaceholder: 'Filter',
                        pieces: 'elements',
                    },
                    notesPage: {
                        title: 'My notes',
                        btnCreateNote: 'New note',
                    },
                    sortRow: {
                        sortClicks: 'Clicks',
                        sortCount: 'Transitions',
                        sortName: 'Name',
                    },
                    updateLinkPage: {},
                    updateProfilePage: {},
                    errorPage: {
                        title: 'An error has occurred!',
                        description: 'Error description will appear here',
                        btnBack: 'To home',
                        btnOK: 'OK',
                        btnCancel: 'Cancel',
                    },
                    uploadFilePage: {
                        title: 'File upload',
                        placeholderName: 'Enter file name',
                        labelTextOne: 'Select file',
                        labelTextMultiple: 'Select files',
                        inputTextOne: 'File selected:',
                        inputTextMultiple: 'Files selected:',
                        buttonBack: 'Back',
                        buttonSend: 'Submit',
                        buttonCancel: 'Cancel',
                        nothingToUpload: 'Nothing to upload',
                        uploadingStatus: 'Uploading status:',
                        file: 'File',
                        isReadyToSend: 'is ready to send!',
                        sizeCannot: 'The uploaded file size cannot be more than 10 MB',
                        notSupported: 'Downloading this file is not supported',
                        pending: 'Pending...',
                        success: 'Success',
                        error: 'Error',
                        uploaded: 'Uploaded',
                        bytesOf: 'bytes of:',
                    },
                    moneyPage: {
                        main: {
                            add: 'Add',
                            addCard: 'Add card',
                            addBank: 'Add account',
                            setCurrency: 'Set currency',
                            settings: 'Settings',
                            addIncome: 'Add income',
                            addCredit: 'Add credit',
                            addPerPayment: 'Add a periodic payment',
                            addPurchase: 'Add purchase',
                            incomes: 'Incomes:',
                            expenses: 'Expenses:',
                            income: 'Income',
                            expense: 'Expense',
                            totalIncome: 'Total Incomes:',
                            totalExpense: 'Total Expenses:',
                            currentExpense: 'Current Expenses:',
                            UpcomingExpense: 'Upcoming Expenses:',
                            balance: 'Balance:',
                            currentBalance: 'Current Balance:',
                            credit: 'Credit',
                            perPayment: 'Periodic (monthly) payment somewhere',
                            purchase: 'One-time purchase or payment for something',
                            name: 'Name',
                            payDate: 'Payment date',
                            purDate: 'Purchase date',
                            total: 'Total',
                            whatIsPayment: 'How payment is made',
                            numberOfPayment: 'Number of payments',
                            expenseInactive: 'This payment method is not active yet. Try using another payment method.',
                            tapeTotal: 'Tape the amount',
                        },
                        periods: {
                            per: 'Period',
                            today: 'Today',
                            yesterday: 'Yesterday',
                            beforeYesterday: 'Day before yesterday',
                            threeDays: 'Three days',
                            week: 'Week',
                            month: '30 days',
                        },
                        isNewUser: {
                            title: 'First set the currency for cash',
                            currency: 'Currency',
                            desc: 'You must set the payment method to "Cash" and specify which currency you will use by default when paying in cash.',
                            setDefault: 'Set as default',
                            buttonSet: 'Set'
                        },
                        filterPlaceholder: 'Start typing...',
                        createNewYear: 'Create a new billing year',
                        currentYear: 'Current year',
                        btnCreate: 'Create',
                        btnCancel: 'Cancel',
                        january: 'January',
                        february: 'February',
                        march: 'March',
                        april: 'April',
                        may: 'May',
                        june: 'June',
                        july: 'July',
                        august: 'August',
                        september: 'September',
                        october: 'October',
                        november: 'November',
                        december: 'December',
                        cash: 'Cash',
                        cardTypeCredit: 'Credit',
                        cardTypeDebit: 'Debit',
                        cardTypeCash: 'Cash',
                    },
                    moneySettingsPage: {
                        oneSameDay: 'Same day',
                        edit: 'Edit',
                        remove: 'Delete',
                        descRemove: 'You want to delete a bank card or payment method. Clicking the "Delete" button will delete the payment method, but all transactions made with it will remain.',
                        defaults: 'Default:',
                        typePayment: 'Payment type:',
                        debitDate: 'Debit date:',
                        currencyCard: 'Card currency:',
                    },
                    cardBankPage: {
                        titleAdd: 'Add new card',
                        titleUpdate: 'Change card details',
                        descAdd: 'Enter the data for the write-off of funds. ' +
                            'If you add a credit card, the write-off will be made on the specified date of the following month. ' +
                            'If the card is a debit card, the write-off will be made at the time of entering the expense data, ' +
                            'as if paying in cash.',
                        descUpdate: 'Change card type. ' +
                            'If it is a credit card, the charge will be made on the specified date of the following month. ' +
                            'If the card is a debit card, the charge will be made at the time of entering the expense data, ' +
                            'as if paying in cash.',
                        btnCreate: 'Add',
                        btnUpdate: 'Change',
                        btnCancel: 'Cancel',
                        labelName: 'Label name',
                        placeholderName: 'Type the card name here',
                        labelType: 'Select card type',
                        labelDate: 'Select the write-off date',
                        textTypeCreditCard: 'Credit card',
                        textTypeDebitCard: 'Debit card',
                        textTypeCash: 'Cash',
                        selectCurrencyLabel: 'Select card currency',
                        currency: 'Card currency',
                        usd: '$ (USD)',
                        ils: '₪ (ILS)',
                        eur: '€ (EUR)',
                        rub: '₽ (RUB)',
                    },
                },
                footer: {
                    contacts: 'Contacts',
                    rights: 'All rights reserved.',
                    policy: 'Privacy Policy',
                },
                modal: {
                    titles: {
                        excellent: 'Excellent!'
                    },
                    errors: {
                        title: 'An error has occurred!',
                        deleteTrialProfile: 'This account cannot be deleted!',
                        desc: {
                            isLife: 'The token has expired. You need to log in to the system again.',
                            copyError: 'An error occurred while copying. Try to repeat the operation.'
                        },
                        btnCancel: 'Cancel',
                        btnOK: 'OK',
                        btnAuth: 'Authorization',
                        btnRestore: 'Restore access',
                        btnAgain: 'Login again',
                        btnTryAgain: 'Try again'
                    },
                    warnings: {
                        title: 'Attention!',
                        desc: {
                            deleteLink: 'When deleted, all data of this link will be lost without the possibility of recovery! Do you really want it?',
                            deleteProfile: 'When you delete your account, all your saved data will be lost without the possibility of recovery. Do you really want it?',
                            deleteNote: 'When deleted, all data of this note will be lost without the possibility of recovery! Do you really want it?',
                            deleteFolder: 'When deleting, this folder and its contents will be moved to the Google Drive trash! Are you sure you want to move it to the trash?',
                            deleteOneMoneyLine: 'If you delete this entry, it will be lost without the possibility of recovery! Do you really want this?',
                            deleteGoogleFolder: 'After deleting, this folder and its contents will be moved to the Google Drive trash! Are you sure you want to move it to the trash?',
                            deleteGoogleFile: 'When deleting, this file will be moved to the Google Drive trash! Are you sure you want to move it to the trash?'
                        },
                        btnCancel: 'Cancel',
                        btnOK: 'Delete'
                    },
                    buttons: {
                        btnToOK: 'OK',
                        btnToMain: 'To Main',
                        btnToAuth: 'Authorization',
                        btnToRegister: 'Registration',
                        btnToBack: 'Back',
                        btnToCancel: 'Cancel'
                    }
                },
                messages: {
                    errorConstruction: 'This page is currently under development. We apologize for the inconvenience.',
                    fillToForm: 'Fill in all required form fields',
                    code_504: 'User is not found! Or you are not authorized! Please log in.',
                    code_540: 'You are not authorized! Please log in or register.',
                    code_541: 'Access to content is prohibited!',
                    code_550: 'The password must be written in English letters and contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, have a length of 6 to 20 characters.',
                    code_551: 'Passwords are not equal.',
                    code_552: 'Incorrect password. You need to fill in the "Old Password" field for confirmation.',
                    code_553: 'Enter the current password',
                    code_554: 'You have successfully changed your password. Now you need to log in again.',
                    code_5541: 'Congratulations! You have successfully registered. Now you need to log in to the system.',
                    code_555: 'Email is misspelled. Check correctness and try again',
                    code_556: 'Not a valid token! Continuation of work is impossible. Try again later',
                    code_590: 'This page is currently under development. We apologize for the inconvenience.',
                    code_591: 'Fill in all required form fields',
                    code_592: 'The form fields are not filled in or filled in incorrectly. The "Name" field must contain at least 3 characters, and in the "Value" field you can only enter a number, and you must use a dot as a separator.',
                    code_593: 'Sorry, but you are not allowed to do this.',
                    code_594: 'The form fields are not filled in or are filled in incorrectly. The "Name" field should not contain the ";" character.',

                    code_600: 'Bad request',
                    code_601: 'Failed to login. Check the correctness of the entered data.',
                    code_6014: 'User is not found. Check that the email you entered is correct.',
                    code_6015: 'User is not found. The link is outdated. You need to request a new link to change your access password.',
                    code_602: 'User already verified',
                    code_603: 'Invalid verification code',
                    code_604: 'Failed to login. Possibly incorrect data entered',
                    code_6041: 'Access token expired',
                    code_6042: 'Re-authorization required! Please log in again.',
                    code_605: 'Email or password was not validated on the server',
                    code_606: 'User with this Email already registered. To log in, use the "Authorization" button',
                    code_607: 'Something went wrong. User not created in database',
                    code_608: 'Failed to send email. Please try again later.',
                    code_609: 'Check email. We have sent you a confirmation code',
                    code_610: 'Failed to create user. You may have entered an invalid email',
                    code_611: 'Email not found',
                    code_612: 'A verification code has been sent to your phone number',
                    code_613: 'Your account has not yet been activated. To activate your account, click "OK" or follow the link from the received letter. In the window that opens, enter the code from the letter and click "Send".',
                    code_614: 'We have sent you a link by email. Use it to change the password for accessing the service.',
                    code_615: 'The password has been changed, now you need to log in with the new password!',

                    code_620: 'Bad request',
                    code_6204: 'Oops...! The folder has been moved or deleted!',
                    code_621: 'A folder with the same name already exists, please specify a different name or use an existing folder',
                    code_622: 'Folder created and saved',
                    code_623: 'Folder with this name not found',
                    code_624: 'Folder deleted!',
                    code_625: 'A folder with the same name already exists! Try a different name',
                    code_626: 'Folder not created! You can\'t paste a folder into itself! Try changing the insertion point',
                    code_627: 'Sorry, but you are not allowed to manage the properties of this folder.',
                    code_628: 'The public link has been created.',

                    code_630: 'Link created and saved in the database!',
                    code_6301: 'The link properties have been changed. Do you want to save these changes?',
                    code_6304: 'Oops...! The link has been moved or deleted!',
                    code_6305: 'Oops...! The Note has been moved or deleted!',
                    code_631: 'A link with the same name already exists in this folder! Try a different name',
                    code_632: 'Such a link already exists in this folder! You cannot create two links to the same place',
                    code_633: 'A folder with the same name already exists in this folder! Set a different name',
                    code_634: 'A note with the same name already exists in this folder! Try a different name',
                    code_635: 'The note has been created and saved in the database!',
                    code_636: 'A credit card with this name already exists! Try another name.',

                    code_640: 'You have not created any accounting year yet. In order to calculate your income and expenses, you need to create an accounting year. Open the window for creating a new billing year?',
                    code_641: 'Congratulations! The new billing year has been created and saved in the database!',

                    code_700: 'Oops... Nothing found. Try changing your search criteria.',
                    code_701: 'Search results will appear here.',
                    code_702: 'Search results:',
                    code_703: 'Found',
                    code_704: 'Folders: ',
                    code_705: 'Links: ',
                    code_706: 'Notes: ',

                    code_655: 'This note name already exists in this directory. The name has not been changed, but the text of the note has been saved!',

                    code_999: 'Internal server error (500)! Something went wrong, please try again later',

                    code_1001: 'Google drive',
                },
                policy: {
                    title: 'Privacy Policy',
                    date: 'Effective Date: 02.06.2025',
                    desc: 'This application ("the App") respects your privacy and is committed to protecting the personal information collected through our services.',
                    par_1: {
                        title: '1. Information We Collect',
                        str_1: 'We may collect the following data:',
                        str_2: 'Required:',
                        str_3: '- Email address',
                        str_4: '- Device system language (automatically detected)',
                        str_5: 'Optional (if provided by the user):',
                        str_6: '- Profile photo',
                        str_7: '- First and last name',
                        str_8: '- Phone number',
                        str_9: '- About/Bio information',
                    },
                    par_2: {
                        title: '2. How We Use Your Information',
                        str_1: 'Collected data is used exclusively for:',
                        str_2: '- User authentication and login',
                        str_3: '- Interface language adaptation',
                        str_4: '- Contacting the user (e.g., via email)',
                        str_5: '- Improving user experience',
                        str_6: 'We do not share your data with third parties without your consent.',
                    },
                    par_3: {
                        title: '3. Data Storage and Security',
                        str_1: 'Your data is stored in a secure cloud environment "MongoDB Atlas".',
                        str_2: 'We apply reasonable technical measures to protect your information.',
                    },
                    par_4: {
                        title: '4. Data Deletion',
                        email: 'using.links.mail@gmail.com',
                        str_1: 'You can request data deletion by contacting:',
                        str_2: 'Your data will be permanently deleted within 30 days.',
                    },
                    par_5: {
                        title: '5. Changes to This Policy',
                        str_1: 'We may update this Privacy Policy periodically.',
                        str_2: 'Updates will be published here with an effective date.',
                    },
                    par_6: {
                        title: '6. Contact',
                        email: 'using.links.mail@gmail.com',
                        str_1: 'Questions? Contact us at:',
                        str_2: 'Email:',
                    },
                }
            }
        }
    }
    if (getLocalStorageItem('language')) {
        language = getLocalStorageItem('language')
    } else {
        language = languages.en
    }
    return {languages, language}
}

export const getQueryParams = () => {
    const res = {}
    for (const [key, value] of new URLSearchParams(window.location.search)) {
        res[key] = value
    }
    return res
}

export const replaceLangUrl = () => {
    let l = 'en'
    if (objectLang().language && objectLang().language.lang) {
        l = objectLang().language.lang
    }
    const url = getPathAndQueryParams()
    const arr = url.split('/')
    if (arr[1]) {
        if (arr[1] !== l) {
            let urlNew = ''
            for (const k in arr) {
                let elem = arr[k]
                if (k === '1') {
                    elem = l
                }
                if (k === String(arr.length - 1)) {
                    urlNew = `${urlNew}${elem}`
                } else {
                    urlNew = `${urlNew}${elem}/`
                }
            }
            window.location.replace(urlNew)
        }
    }
}

export const deleteCookies = () => {
    const languages = getLocalStorageItem('languages')
    const language = getLocalStorageItem('language')
    localStorage.clear()
    setLocalStorageItem('languages', languages)
    setLocalStorageItem('language', language)
}

export const validationPassword = (passOne, passTwo, isRegister = false) => {
    const regexp = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/
    let result = {res: '', code: '', flag: false}
    if (!passOne.match(regexp)) {
        result.code = 550
    } else if (!isRegister) { // Если нет второго пароля, значит вызываем функцию из авторизации
        result.res = passOne
        result.flag = true
    } else if (passOne !== passTwo) {
        result.code = 551
    } else {
        result.res = passOne
        result.flag = true
    }
    return result
}

export const validationEmail = (str) => {
    const regexp = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/
    let result = {res: '', code: '', flag: false}
    if (!str.match(regexp)) {
        result.code = 555
    } else {
        result.res = str
        result.flag = true
    }
    return result
}

function isString(x) {
    return Object.prototype.toString.call(x) === '[object String]'
}

export const reformatDate = (date, sep = '.') => {
    if (isString(date)) {
        date = date.split('T')[0]
        const split = date.split('-')
        return split[2] + sep + split[1] + sep + split[0]
    }
    return ''
}

export const set_select_by_value = (select_id, option_val) => {
    $(`#${select_id} option[value='${option_val}']`).prop('selected', true)
}

export const eyeHandler = (jqueryEye, jqueryPassword) => {
    if (jqueryEye.hasClass('fa-eye-slash')) {
        jqueryEye.removeClass('fa-eye-slash').addClass('fa-eye')
        jqueryPassword.attr('type', 'text')
    } else {
        jqueryEye.removeClass('fa-eye').addClass('fa-eye-slash')
        jqueryPassword.attr('type', 'password')
    }
}

export const autoResize = (el) => {
    if (!el) return
    const lineHeight = 16
    const maxRows = 5
    const maxHeight = lineHeight * maxRows

    el.style.height = 'auto'
    if (el.scrollHeight > maxHeight) {
        el.style.height = maxHeight + 'px'
        el.style.overflowY = 'auto'
    } else {
        el.style.height = el.scrollHeight + 'px'
        el.style.overflowY = 'hidden'
    }
}

export const changeHandler = (event) => {
    const from = event.target
    const btnSave = $('#btn-save')
    const value = event.target.value
    if (btnSave.hasClass('disabled')) {
        btnSave.removeClass('disabled')
    }
    from.style.color = 'red'
    !value ? from.classList.remove('form-detail') : from.classList.add('form-detail')
}

export const clickUpdateHandler = () => {
    const lang = getLocalStorageItem('language')

    const update = () => {
        $('#first-name-profile').attr('disabled', false)
        $('#last-name-profile').attr('disabled', false)
        $('#nick-name-profile').attr('disabled', false)
        $('#phone-number-profile').attr('disabled', false)
        $('#language-profile').attr('disabled', false)
        $('#about-me-profile').attr('disabled', false)
        $('#password-old-profile').attr('disabled', false)
        $('#password-new-profile').attr('disabled', false)
        $('#password-repeat-profile').attr('disabled', false)
        $('#link-update').html(lang.body.profilePage.cancelUpdateProfile)
        $('#btn-update').removeClass('disabled')
    }

    const cancelUpdate = () => {
        $('#first-name-profile').attr('disabled', true)
        $('#last-name-profile').attr('disabled', true)
        $('#nick-name-profile').attr('disabled', true)
        $('#phone-number-profile').attr('disabled', true)
        $('#language-profile').attr('disabled', true)
        $('#about-me-profile').attr('disabled', true)
        $('#password-old-profile').attr('disabled', true).val('')
        $('#password-new-profile').attr('disabled', true).val('')
        $('#password-repeat-profile').attr('disabled', true).val('')
        $('#link-update').html(lang.body.profilePage.updateProfile)
        $('#btn-update').addClass('disabled')
    }

    const divPass = $('#divPasswords')
    if (divPass.hasClass('d-none')) {
        divPass.removeClass('d-none')
        update()
    } else {
        divPass.addClass('d-none')
        cancelUpdate()
    }
}

export const contextMenuItem = (e, key) => {
    const contextMenuItemArr = document.querySelectorAll(".context-menu-item")
    contextMenuItemArr.forEach((element) => {
        element.classList.add('d-none')
    })
    if (e.target.id === "img-folder" || e.target.id === "img-link" || e.target.id === "img-note" || e.target.id === "img-context-menu" ||
        e.target.id === "name-folder" || e.target.id === "link-from" || e.target.id === "p-link-from" || e.target.id === "name-note") {
        contextMenuOff(e)
        e.preventDefault()
        let contextMenuItem = document.querySelector(`#context-menu-item-${key}`)
        positionMenu(contextMenuItem, e, false)
    } else {
        contextMenuOff(e)
    }
}

export const checkAllowed = (auth, owner) => {
    const isAuth = auth['isAuthenticated']
    let reader = auth['userId'] ? auth['userId'] : undefined
    return isAuth && reader === owner
}

export const contextMenuCreateItem = (e) => {
    if (e.target.id === "row-items" || e.target.id === "main-container" || e.target.id === "body-items") {
        contextMenuOff(e)
        e.preventDefault()
        const contextMenuCreate = document.querySelector(`#context-menu-create`)
        positionMenu(contextMenuCreate, e, true)
        let isCopyFolder = !!getLocalStorageItem('copyFolder'),
            isCopyLink = !!getLocalStorageItem('copyLink'),
            isCopyNote = !!getLocalStorageItem('copyNote')
        if (isCopyFolder || isCopyLink || isCopyNote) {
            document.querySelector('#context-menu-clear-buffer').classList.remove('d-none')
        } else {
            document.querySelector('#context-menu-clear-buffer').classList.add('d-none')
            document.querySelector('#context-menu-paste-folder').classList.add('d-none')
            document.querySelector('#context-menu-paste-link').classList.add('d-none')
            document.querySelector('#context-menu-paste-note').classList.add('d-none')
        }
    }
}

export const menuCreateItem = (e) => {
    const contextMenuItemArr = document.querySelectorAll(".context-menu-item")
    const contextMenuCreateArr = document.querySelectorAll(".context-menu-create")
    contextMenuItemArr.forEach((element) => {
        element.classList.add('d-none')
    })
    contextMenuCreateArr.forEach((element) => {
        element.classList.add('d-none')
    })
    e.preventDefault()
    const contextMenu = document.querySelector("#context-menu-create")
    positionMenu(contextMenu, e, true)
}

export const removeSearchParameter = () => {
    const history = createBrowserHistory()
    if (history.location.search) {
        history.push(history.location.pathname)
    }
}

export const showAll = () => {
    const arr = Array.from(document.getElementById('items').children)
    if (arr) {
        for (const i in arr) {
            arr[i].classList.remove("d-none")
        }
    }
}

export const filterHandler = (value, documents, allCounts) => {

    value ? value = value.toLowerCase() : value = ''

    const ifElse = (arr, filter, name, subText, linkDesc = '') => {
        let count = 0
        if (name && filter && subText && linkDesc) {
            if (name.includes(filter) || subText.includes(filter) || linkDesc.includes(filter)) {
                arr.classList.remove("d-none")
                count++
            } else {
                arr.classList.add("d-none")
            }
        } else if (name && filter && subText) {
            if (name.includes(filter) || subText.includes(filter)) {
                arr.classList.remove("d-none")
                count++
            } else {
                arr.classList.add("d-none")
            }
        } else if (name && filter && !subText) {
            if (name.includes(filter)) {
                arr.classList.remove("d-none")
                count++
            } else {
                arr.classList.add("d-none")
            }
        }
        return count
    }

    const filtering = (type, filter, name, subText = '', linkDesc = '') => {
        const arr = Array.from(document.getElementById('items').children)
        let count = 0
        for (const i in arr) {
            const elem = arr[i].childNodes[0]
            const indexName = elem.childNodes.length - 1
            const arrIName = elem.childNodes[indexName].textContent.toLowerCase()
            if (type === 'folder' && arrIName === name) {
                if (arr[i].classList[0] === 'folder') {
                    count += ifElse(arr[i], filter, name, subText)
                }
            }
            if (type === 'google-folder') {
                if (arr[i].classList[0] === 'google-folder' && arrIName === name) {
                    count += ifElse(arr[i], filter, name, subText)
                }
            }
            if (type === 'google-file') {
                if (arr[i].classList[0] === 'google-file' && arrIName === name) {
                    count += ifElse(arr[i], filter, name, subText)
                }
            }
            if (type === 'link' && arrIName === name) {
                if (arr[i].classList[0] === 'link') {
                    count += ifElse(arr[i], filter, name, subText, linkDesc)
                }
            }
            if (type === 'note' && arrIName === name) {
                if (arr[i].classList[0] === 'note') {
                    count += ifElse(arr[i], filter, name, subText)
                }
            }
        }
        return count
    }

    if (document.getElementById('items')) {
        const folders = documents.folders
        const links = documents.links
        const notes = documents.notes
        let c = 0
        for (const i in folders) {
            let name, description
            if (folders[i]['type'] === 'folder') {
                folders[i].name ? name = folders[i].name.toLowerCase() : name = ''
                folders[i].description ? description = folders[i].description.toLowerCase() : description = ''
                c += filtering('folder', value, name, description)
            } else if (folders[i]['type'] === 'google-folder') {
                folders[i].name ? name = folders[i].name.toLowerCase() : name = ''
                c += filtering('google-folder', value, name)
            }
        }
        for (const i in links) {
            let name, from, desc
            if (links[i]['type'] === 'link') {
                links[i].name ? name = links[i].name.toLowerCase() : name = ''
                links[i].from ? from = links[i].from.toLowerCase() : from = ''
                links[i].description ? desc = links[i].description.toLowerCase() : desc = ''
                c += filtering('link', value, name, from, desc)
            } else if (links[i]['type'] === 'google-file') {
                links[i].name ? name = links[i].name.toLowerCase() : name = ''
                c += filtering('google-file', value, name)
            }
        }
        for (const i in notes) {
            let name, body
            notes[i].name ? name = notes[i].name.toLowerCase() : name = ''
            notes[i].body ? body = notes[i].body.toLowerCase() : body = ''
            c += filtering('note', value, name, body)
        }
        if (c === 0 && document.getElementById('filterInput').value === '') {
            return allCounts
        }
        return c
    }
}

export const filterMoneyHandler = (e, arr, factor) => {
    const resArr = []
    let preTotal = 0
    const inputText = e.target.value.toLowerCase()
    if (!inputText) {
        return {names: resArr, preTotal: preTotal}
    }
    if (factor === 'month-all') {
        for (const i in arr) {
            const nameArr = arr[i][1].toLowerCase()
            if (nameArr.includes(inputText)) {
                resArr.push(nameArr)
                if (arr[i][3]) {
                    preTotal += arr[i][3]
                }
            }
        }
    }

    if (factor === 'year-all') {
        for (const i in arr) {
            const nameArr = arr[i][1].toLowerCase()
            if (nameArr.includes(inputText)) {
                resArr.push(nameArr)
                if (arr[i][3]) {
                    preTotal += arr[i][3]
                }
            }
        }
    }

    if (factor === 'year' || factor === 'month') {
        for (const i in arr) {
            const nameArr = arr[i][0].toLowerCase()
            if (nameArr.includes(inputText)) {
                resArr.push(nameArr)
                if (arr[i][1]) {
                    preTotal += arr[i][1]
                }
            }
        }
    }

    return {names: resArr, preTotal: Number(preTotal.toFixed(2))}
}

export const hideHandler = (arr, parentId, factor) => {
    const children = document.querySelector(`#${parentId}`).childNodes
    for (const child of children) {
        child.classList.remove('d-none')
        child.classList.remove('true')
    }

    if (arr.length > 0) {
        for (const i in arr) {
            for (const child of children) {
                let textContent = '0'
                if (factor === 'month-all' || factor === 'year') {
                    if (child.childNodes[0]) {
                        if (child.childNodes[0].childNodes[0]) {
                            if (child.childNodes[0].childNodes[0].textContent) {
                                textContent = child.childNodes[0].childNodes[0].textContent.toLowerCase()
                            }
                        }
                    }
                } else {
                    if (child.childNodes[1]) {
                        if (child.childNodes[1].childNodes[0]) {
                            if (child.childNodes[1].childNodes[0].textContent) {
                                textContent = child.childNodes[1].childNodes[0].textContent.toLowerCase()
                            }
                        }
                    }
                }

                if (child.childNodes[0]['id']) {
                    if (textContent === arr[i] && !child.classList.contains('true')) {
                        child.classList.remove('d-none')
                        child.classList.add('true')
                    }
                    if (textContent !== arr[i] && !child.classList.contains('true')) {
                        child.classList.add('d-none')
                    }
                }
            }
        }
    } else {
        for (const child of children) {
            if (!child.classList.contains('filter') && (document.querySelector(`#expenses-filter`).value || document.querySelector(`#incomes-filter`).value)) {
                child.classList.add('d-none')
            } else {
                child.classList.remove('d-none')
            }
        }
    }
}

export const contextMenuOff = (e) => {
    if (e.target.id !== 'img-context-menu' && e.target.className !== 'fa-solid fa-plus' && e.target.className !== 'btn btn-light me-2 fs-6') {

        const contextMenuItemArr = document.querySelectorAll(".context-menu-item")
        const contextMenuCreateArr = document.querySelectorAll(".context-menu-create")
        contextMenuItemArr.forEach((element) => {
            element.classList.add('d-none')
        })
        contextMenuCreateArr.forEach((element) => {
            element.classList.add('d-none')
        })
    }
}

export const createCookiesOfName = (name, data) => {
    setLocalStorageItem(name, data)
}

export const clearBuffer = () => {
    localStorage.removeItem('copyFolder')
    localStorage.removeItem('cutFolder')
    localStorage.removeItem('copyLink')
    localStorage.removeItem('cutLink')
    localStorage.removeItem('copyNote')
    localStorage.removeItem('cutNote')
    document.querySelector('#context-menu-paste-folder').classList.add('d-none')
    document.querySelector('#context-menu-paste-link').classList.add('d-none')
    document.querySelector('#context-menu-paste-note').classList.add('d-none')
    document.querySelector('#context-menu-clear-buffer').classList.add('d-none')
}

export const stringToNumberOrString = (value) => {
    if (typeof value !== 'string') return value

    const digits = value.match(/\d/g)
    if (!digits) return value

    return Number(digits.join(''))
}

export function sortItems(items, { field = 'name', order = 'asc' } = {}) {
    const TYPE_ORDER = { folder: 0, link: 1, note: 2 }
    const dir = order === 'asc' ? 1 : -1

    return [...items].sort((a, b) => {

        // TYPE: сначала тип, внутри типа name ASC
        if (field === 'type') {
            const typeDiff =
                (TYPE_ORDER[a.type] - TYPE_ORDER[b.type]) * dir

            if (typeDiff !== 0) return typeDiff

            // внутри одного типа — name ASC
            const aNum = stringToNumberOrString(a.name)
            const bNum = stringToNumberOrString(b.name)
            const numDiff = (aNum - bNum) * dir

            if (Number.isNaN(numDiff) || numDiff === 0) {
                return a.name.localeCompare(b.name, ['ru', 'en'], { sensitivity: 'base' }) * dir
            }

            return numDiff
        }

        // NAME
        if (field === 'name') {
            const aNum = stringToNumberOrString(a.name)
            const bNum = stringToNumberOrString(b.name)
            const numDiff = (aNum - bNum) * dir

            if (Number.isNaN(numDiff) || numDiff === 0) {
                return a.name.localeCompare(b.name, ['ru', 'en'], { sensitivity: 'base' }) * dir
            }

            return numDiff
        }

        // DATE
        if (field === 'date') {
            return (new Date(a.dateCreated) - new Date(b.dateCreated)) * dir
        }

        return 0
    })
}

export const getItems = (documents) => {

    function uniqueByKey(arr, key) {
        const seen = new Set()
        return arr.filter(item => {
            const k = item[key]
            if (seen.has(k)) return false
            seen.add(k)
            return true
        })
    }

    let res = []
    const folders = documents.folders
    const links = documents.links
    const notes = documents.notes

    folders.forEach((folder) => {
        res.push(folder)
    })
    links.forEach((link) => {
        res.push(link)
    })
    notes.forEach((note) => {
        res.push(note)
    })
    const result = uniqueByKey(res, 'name')
    if (result.length < 1) {
        result.push({type: ''})
    }

    return sortItems(result, { field: documents.sort, order: documents.order }) // order 'asc' or 'desc'
}

export const positionMenu = (menu, e, isMenuItem) => {
    const windowInnerWidth = document.documentElement.clientWidth
    const windowInnerHeight = document.documentElement.clientHeight
    const copyFolder = getLocalStorageItem('copyFolder')
    const copyLink = getLocalStorageItem('copyLink')
    const copyNote = getLocalStorageItem('copyNote')
    let addPixelsHeight = 16 + 121.5
    let addPixelsWidth = 100
    if (isMenuItem) {
        addPixelsWidth = 200
    }
    if (copyFolder) {
        addPixelsHeight += 40.5
    }
    if (copyLink) {
        addPixelsHeight += 40.5
    }
    if (copyNote) {
        addPixelsHeight += 40.5
    }

    const bottomDot = e.clientY + addPixelsHeight
    const rightDot = e.clientX + addPixelsWidth

    if (rightDot > windowInnerWidth) {
        if ((e.clientX - addPixelsWidth) < 0) {
            menu.style.left = `0px`
        } else {
            menu.style.left = `${e.clientX - addPixelsWidth}px`
        }
    } else {
        menu.style.left = `${e.clientX}px`
    }
    if (bottomDot > windowInnerHeight) {
        if ((e.clientY - 200) < 0) {
            menu.style.top = `0px`
        } else {
            menu.style.top = `${e.clientY - addPixelsHeight}px`
        }
    } else {
        menu.style.top = `${e.clientY}px`
    }
    menu.className = 'context-menu-item'
}

export const justifyContents = (items) => {
    let scrollWidth = document.documentElement.scrollWidth
    let body_items_justify = 'justify-content-center'
    let row_items_justify = 'justify-content-center'
    let row_justify = 'justify-content-center'
    let length = 0
    if (items) {
        length = items.length
        if (scrollWidth >= 992) { // lg
            if (length < 9) {
                body_items_justify = 'justify-content-between'
            } else {
                body_items_justify = 'justify-content-center'
            }
            row_justify = 'justify-content-start'
        } else if (scrollWidth < 992 && scrollWidth >= 768) { // md
            body_items_justify = 'justify-content-center'
            row_items_justify = 'justify-content-center'
            row_justify = 'justify-content-center'
        } else if (scrollWidth < 768) { // xs
            body_items_justify = 'justify-content-center'
            row_items_justify = 'justify-content-center'
            row_justify = 'justify-content-between'
        }
        if (length <= 9) {
            scrollWidth = length * 136
        } else {
            scrollWidth = 9 * 136
        }
        if (length >= 9) {
            row_items_justify = 'justify-content-center'
        }
    }
    return {
        scrollWidth,
        body_items_justify,
        row_justify,
        row_items_justify
    }
}

export const getImagePath = (documents, user) => {

    let res = `U_${user.userId}/FILES`
    if (documents.upLevel === 'root') {
        res = `U_${user.userId}/FILES/F_${user.rootFolder}`
    }
    const arrPath = documents.path
    for (const i in arrPath) {
        const folderId = arrPath[i][1]
        if (folderId === '0') {
            continue
        }
        res += `/F_${folderId}`
    }

    let now = new Date()

    const nameFile = `image_${dateFormat(now)}`
    return `${res}/${nameFile.replace(/[\s.,;:]/g, '')}`
}

export const getAvatarImagePath = (user) => {
    let res = `U_${user.userId}/AVATARS`
    let now = new Date()
    const nameFile = `image_${dateFormat(now)}`
    return `${res}/${nameFile.replace(/[\s.,;:]/g, '')}`
}

export const dateFormat = (date) => {
    // format = 'dd.mm.year_hour:mm:ss_ms'
    let d = new Date(date)
    let zero
    d.getMonth() + 1 <= 9 ? zero = '0' : zero = ''
    return `${d.getDate()}.${zero}${d.getMonth() + 1}.${d.getFullYear()}_${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}_${d.getMilliseconds()}`
}

export const setCheckIconLink = async (htmlId, from, flagCheckTrue, flagCheckFalse, flagCheckEmpty) => {
    setTimeout(() => {
        const icon = document.querySelector(`#${htmlId}`)
        if (icon) {
            if (!from.includes('https')) {
                icon.src = flagCheckFalse
            } else {
                try {
                    $.ajax({
                        url: from,
                        async: true,
                        complete: (res) => {
                            if (res.statusText === "success") {
                                icon.src = flagCheckTrue
                            } else if (res.statusText === "error") {
                                icon.src = flagCheckEmpty
                            }
                        }
                    })
                } catch (e) {
                    icon.src = flagCheckEmpty
                }
            }
        }
    }, 100)
}

export const setCookieOfName = (name, value) => {
    setLocalStorageItem(name, value)
}

export const setLocalStorageItem = (name, value) => {
    if (typeof value === 'string') {
        localStorage.setItem(name, value)
    } else {
        localStorage.setItem(name, JSON.stringify(value))
    }
}

export const getLocalStorageItem = (name) => {
    const value = localStorage.getItem(name)
    if (value === null) return null
    try {
        return JSON.parse(value)
    } catch {
        return value
    }
}

export const removeLocalStorageItem = (name) => {
    localStorage.removeItem(name)
}

export const getIdsOfPath = (path) => {
    let res = {}
    for (const i in path) {
        res[i] = path[i][1]
    }
    return res
}

export const setCookieOfFolder = (documents) => {
    setLocalStorageItem(documents.parent, documents)
}

export const removeCookieOfFolderId = (folderId) => {
    localStorage.removeItem(folderId)
}

export const checkNumber = (number) => {
    const regexp = new RegExp("^(0|[1-9]\\d*)([.]\\d+)?$")
    return regexp.test(number)
}

export const checkDot = (e) => {
    let num = e.target.value
    if (num.includes(',')) {
        num = num.replace(',', '.')
        document.querySelector('#input-value').value = num
    }
}

export const checkDataObject = (dataObject, arrNames) => {
    let res = true
    for (const i in arrNames) {
        if (!dataObject[arrNames[i]]) {
            res = false
        }
    }
    return res
}

export const parseNameWithDate = (fieldName) => {
    const arr = fieldName.split(';')
    if (arr.length >= 2) {
        const date = formatDateToStr(new Date(Number(arr[0])))
        const name = arr[1]
        let means = '', datePay = ''
        if (arr[2]) {
            means = arr[2]
        }
        if (arr[3]) {
            datePay = formatDateToStr(new Date(Number(arr[3])))
        }
        return {date, name, means, datePay}
    } else {
        return fieldName
    }
}

export const getDateNumber = (dateStr) => {
    const dateArr = dateStr.split('.')
    const now = new Date()
    return new Date(Number(dateArr[2]), Number(dateArr[1]) - 1, Number(dateArr[0]), now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds()).getTime()
}

export const getTimeNumberFromZeroDateToday = () => {
    return {start: Number(zeroNumber), end: getDateNumber(formatDateToStr())}
}

export const getTimeNumberFromZeroDateYesterday = () => {
    return {start: Number(zeroNumber) - dayNum, end: Number(zeroNumber)}
}

export const getTimeNumberFromZeroDateBeforeYesterday = () => {
    return {start: Number(zeroNumber) - (dayNum * 2), end: Number(zeroNumber) - dayNum}

}

export const getTimeNumberFromZeroDateThreeDay = () => {
    return {start: Number(zeroNumber) - (dayNum * 2), end: getDateNumber(formatDateToStr())}
}

export const getTimeNumberFromZeroDateWeek = () => {
    return {start: Number(zeroNumber) - (dayNum * 7), end: getDateNumber(formatDateToStr())}
}

export const getTimeNumberFromZeroDateMonth = () => {
    return {start: Number(zeroNumber) - (dayNum * 30), end: getDateNumber(formatDateToStr())}
}

export const sortDate = (a, b, index) => {
    if (a[index] > b[index]) {
        return -1
    } else if (a[index] < b[index]) {
        return 1
    } else {
        return 0
    }
}

export const formatDateToStr = (dateNumber = 0, format = 'DD.MM.yyyy') => {
    if (!dateNumber) {
        dateNumber = Date.now()
    }
    return moment(dateNumber).format(format)
}

export const checkName = (name) => {
    return !name.includes(';')
}

export const navbarNavClick = (event, isNewPage = false) => {
    const toggle = $('#navbar-nav')
    $('.navbar-nav').removeClass('ms-5')
    if (isNewPage) {
        toggle.removeClass('show')
        return
    }
    if (toggle.hasClass('show')) {
        toggle.removeClass('show')
    } else {
        toggle.addClass('show')
    }
}

export const addUniqueItemToArr = (arr, item) => {
    let isInclude = false
    for (const i in arr) {
        if (arr[i] === item) {
            isInclude = true
        }
    }
    if (!isInclude) {
        arr.push(item)
    }
}

export const getIncomesTotalOfYear = (yearName, incomes) => {
    let result = 0
    for (const i in incomes) {
        const year = new Date(incomes[i]['payment_date']).getFullYear()
        const value = incomes[i]['value']
        if (yearName === year) {
            result += value
        }
    }
    return Number(result).toFixed(2)
}

export const getExpensesTotalOfYear = (yearName, expenses) => {
    let result = 0, preExpenses = getPreExpensesOfYear(yearName, expenses)
    for (const i in expenses) {
        const year = new Date(expenses[i]['purchase_date']).getFullYear()
        const value = expenses[i]['value']
        if (yearName === year) {
            result += value
        }
    }
    return (Number(result) - Number(preExpenses)).toFixed(2)
}

export const getPreExpensesOfYear = (yearName, expenses) => {
    let result = 0
    const nowNum = new Date().getTime()
    for (const i in expenses) {
        const year = new Date(expenses[i]['purchase_date']).getFullYear()
        const value = expenses[i]['value']
        if (nowNum < Number(expenses[i]['payment_date']) && yearName === year) {
            result += value
        }
    }
    return Number(result).toFixed(2)
}

export const getBalanceOfYear = (yearName, incomes, expenses) => {
    let resultInc = 0, resultExp = 0, preExpenses = getPreExpensesOfYear(yearName, expenses)
    for (const i in incomes) {
        const year = new Date(Number(i)).getFullYear()
        const value = incomes[i]['value']
        if (yearName === year) {
            resultInc += value
        }
    }
    for (const i in expenses) {
        const year = new Date(expenses[i]['purchase_date']).getFullYear()
        const value = expenses[i]['value']
        if (yearName === year) {
            resultExp += value
        }
    }
    return (Number(resultInc) - Number(resultExp) + Number(preExpenses) + 0.001).toFixed(2)
}

export const getDataMonthTotal = (yearName, monthNum, purpose, calculation) => {
    let result = 0
    for (const i in purpose) {
        const year = new Date(purpose[i][calculation]).getFullYear()
        const month = new Date(purpose[i][calculation]).getMonth()
        const value = purpose[i]['value']
        if (yearName === year && monthNum === month && value) {
            result = result + value
        }
    }
    return Number(result.toFixed(2))
}

export const getIncomesTotal = (incomes, isAllFields) => {
    let result = {}
    if (isAllFields) {
        for (const inc in incomes) {
            result[inc] = Number(incomes[inc].toFixed(2))
        }
    } else {
        for (const inc in incomes) {
            const value = incomes[inc]
            const name = inc.split(';')[1]
            if (result[name]) {
                result[name] += Number(value.toFixed(2))
            } else {
                result[name] = Number(value.toFixed(2))
            }
        }
    }
    return result
}

export const getExpensesTotal = (expenses, calculation, month, isAllFields) => {
    let result = {}, m = -1
    if (calculation === 'payment') {
        if (isAllFields) {
            for (const exp in expenses) {
                m = new Date(Number(exp.split(';')[3])).getMonth() // Payment date
                if (m === month) {
                    result[exp] = expenses[exp]
                }
            }
        } else {
            for (const exp in expenses) {
                m = new Date(Number(exp.split(';')[3])).getMonth() // Payment date
                const value = expenses[exp]
                const name = exp.split(';')[1]
                if (m === month) {
                    if (result[name]) {
                        result[name] += value
                    } else {
                        result[name] = value
                    }
                }
            }
        }
    } else if (calculation === 'purchase') {
        if (isAllFields) {
            for (const exp in expenses) {
                m = new Date(Number(exp.split(';')[0])).getMonth() // Purchase date
                if (m === month) {
                    result[exp] = expenses[exp]
                }
            }
        } else {
            for (const exp in expenses) {
                m = new Date(Number(exp.split(';')[0])).getMonth() // Purchase date
                const value = expenses[exp]
                const name = exp.split(';')[1]
                if (m === month) {
                    if (result[name]) {
                        result[name] += value
                    } else {
                        result[name] = value
                    }
                }
            }
        }
    }
    for (const i in result) {
        result[i] = Number(result[i].toFixed(2))
    }
    return result
}

export const getMonthsNum = (monthStr) => {
    const objMonths = {
        january: 0,
        february: 1,
        march: 2,
        april: 3,
        may: 4,
        june: 5,
        july: 6,
        august: 7,
        september: 8,
        october: 9,
        november: 10,
        december: 11
    }
    return objMonths[monthStr]
}

export function reloadOnceWithoutCache() {
    const url = new URL(window.location.href)
    if (!url.searchParams.has('nocache')) {
        url.searchParams.set('nocache', Date.now())
        window.location.replace(url.toString())
    }
}

export const getValuesOfNames = (arr, callback) => {
    let objNames = {}
    for (const i in arr) {
        const a = arr[i]
        for (const k in a) {
            const obj = a[k]
            if (obj instanceof Object) {
                for (const field in obj) {
                    const name = field.split(';')[1]
                    const value = obj[field]
                    if (objNames[name]) {
                        objNames[name] = objNames[name] + value
                    } else {
                        objNames[name] = value
                    }
                }
            }
        }
    }
    for (const k in objNames) {
        callback.push([k, Number(objNames[k].toFixed(2))])
    }
}

export const getValuesAllNames = (arr, callback) => {
    for (const elem of arr) {
        for (const e in elem) {
            if (Object.prototype.toString.call(elem[e]) === '[object Object]') {
                const month = elem[e]
                for (const k in month) {
                    const name = k.split(';')[1]
                    const field = k.split(';')[0]
                    const value = month[k]
                    callback.push([parseNameWithDate(k).date, parseNameWithDate(k).name, parseNameWithDate(k).means, value, name, field])
                }
            }
        }
    }
}

export const getPathBack = () => {
    return localStorage.getItem('pathBack')
}

export const setPathBack = (path) => {
    let p = path ? path : window.location.pathname + window.location.search
    setLocalStorageItem('pathBack', p)
}

export const getMoneyPathBack = () => {
    return getLocalStorageItem('moneyPathBack')
}

export const setMoneyMonthDetailPath = (path) => {
    setLocalStorageItem('moneyMonthDetailPathBack', path)
}

export const getMoneyMonthDetailPath = () => {
    return getLocalStorageItem('moneyMonthDetailPathBack')
}

export const setMoneyPathBack = (path) => {
    setLocalStorageItem('moneyPathBack', path)
}

export const setGlobalMoneyObject = (money) => {

    const incomes = money['incomes']
    const expenses = money['expenses']
    const months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september',
        'october', 'november', 'december']
    let years = [], yearsObject = {}

    const dataNav = {
        pathBack: `/main`,
        isMain: true,
        isMoney: false,
        isSetting: true,
        isAddIncome: true,
        isAddCredit: true,
        isAddPurchase: true,
        isYearDetail: false,
        isMonthDetail: true,
        isSelectPeriod: true,
        currency: money['settings']['currencies'][money['settings']['currency']]
    }

    let globalMoneyObject = {
        incomes: incomes,
        expenses: expenses,
        general: money,
        nav: dataNav,
    }

    if (incomes || expenses) {
        if (incomes) {
            const incArr = Object.keys(incomes)
            for (const i in incArr) {
                const field = incArr[i]
                const fieldNum = Number(field)
                const year = new Date(fieldNum).getFullYear()
                addUniqueItemToArr(years, year)
            }
        }
        if (expenses) {
            const expArr = Object.keys(expenses)
            for (const i in expArr) {
                const paymentDate = expenses[expArr[i]]['payment_date']
                const year = new Date(paymentDate).getFullYear()
                addUniqueItemToArr(years, year)
            }
        }
    }
    if (years.length > 0) {
        for (const year of years) {
            for (const month of months) {
                if (!yearsObject[year]) {
                    yearsObject[year] = {}
                }
                if (!yearsObject[year]['months']) {
                    yearsObject[year]['months'] = {}
                }
                if (!yearsObject[year]['months'][month]) {
                    yearsObject[year]['months'][month] = {}
                }
                if (!yearsObject[year]['months'][month]['income']) {
                    yearsObject[year]['months'][month]['income'] = {}
                }
                if (!yearsObject[year]['months'][month]['expensePayment']) {
                    yearsObject[year]['months'][month]['expensePayment'] = {}
                }
                if (!yearsObject[year]['months'][month]['expensePurchase']) {
                    yearsObject[year]['months'][month]['expensePurchase'] = {}
                }
            }
        }
        for (const i in incomes) {
            const dateNum = incomes[i]['payment_date']
            const fullYear = new Date(dateNum).getFullYear()
            const monthNum = new Date(dateNum).getMonth()
            const monthName = months[monthNum]
            yearsObject[fullYear]['months'][monthName]['income'][`${dateNum};${incomes[i]['name']};${incomes[i]['purpose']};${incomes[i]['currency']}`] = Number(incomes[i]['value'].toFixed(2))
            yearsObject[fullYear]['months'][monthName]['incomesMonthTotalPayment'] = getDataMonthTotal(fullYear, monthNum, incomes, 'payment_date')
            yearsObject[fullYear]['months'][monthName]['incomesMonthTotalPurchase'] = getDataMonthTotal(fullYear, monthNum, incomes, 'purchase_date')
        }
        for (const i in expenses) {
            const paymentDateNum = expenses[i]['payment_date']
            const purchaseDateNum = expenses[i]['purchase_date']
            const fullYear = new Date(purchaseDateNum).getFullYear()
            const monthNumPayment = new Date(paymentDateNum).getMonth()
            const monthNumPurchase = new Date(purchaseDateNum).getMonth()
            const monthNamePayment = months[monthNumPayment]
            const monthNamePurchase = months[monthNumPurchase]
            yearsObject[fullYear]['months'][monthNamePayment]['expensePayment'][`${purchaseDateNum};${expenses[i]['name']};${expenses[i]['cardId']};${paymentDateNum};${expenses[i]['currency']};${expenses[i]['countCurrent']};${expenses[i]['TotalCount']};${expenses[i]['preTotalValue']};${expenses[i]['totalValue']}`] = Number(expenses[i]['value'].toFixed(2))
            yearsObject[fullYear]['months'][monthNamePurchase]['expensePurchase'][`${purchaseDateNum};${expenses[i]['name']};${expenses[i]['cardId']};${paymentDateNum};${expenses[i]['currency']};${expenses[i]['countCurrent']};${expenses[i]['TotalCount']};${expenses[i]['preTotalValue']};${expenses[i]['totalValue']}`] = Number(expenses[i]['value'].toFixed(2))
            yearsObject[fullYear]['months'][monthNamePayment]['expensesMonthTotalPayment'] = getDataMonthTotal(fullYear, monthNumPayment, expenses, 'payment_date')
            yearsObject[fullYear]['months'][monthNamePurchase]['expensesMonthTotalPurchase'] = getDataMonthTotal(fullYear, monthNumPurchase, expenses, 'purchase_date')
        }
    }

    const yearsArr = []

    for (const yearName of years) {
        yearsArr.unshift({
            yearName: yearName,
            incomesTotal: getIncomesTotalOfYear(yearName, incomes),
            expensesTotal: getExpensesTotalOfYear(yearName, expenses),
            preExpense: getPreExpensesOfYear(yearName, expenses),
            balance: getBalanceOfYear(yearName, incomes, expenses),
            currency: money['settings']['currencies'][money['settings']['currency']]
        })
        globalMoneyObject[yearName] = yearsObject[yearName]
        globalMoneyObject[yearName]['incomesTotal'] = getIncomesTotalOfYear(yearName, incomes)
        globalMoneyObject[yearName]['expensesTotal'] = getExpensesTotalOfYear(yearName, expenses)
        globalMoneyObject[yearName]['preExpense'] = getPreExpensesOfYear(yearName, expenses)
        globalMoneyObject[yearName]['balance'] = getBalanceOfYear(yearName, incomes, expenses)
        globalMoneyObject[yearName]['currency'] = money['settings']['currencies'][money['settings']['currency']]

        const globalYear = globalMoneyObject[yearName]

        for (const i in globalYear['months']) {
            if (!globalMoneyObject[yearName]['months'][i]['incomesMonthTotalPayment']) {
                globalMoneyObject[yearName]['months'][i]['incomesMonthTotalPayment'] = 0
            }
            if (!globalMoneyObject[yearName]['months'][i]['incomesMonthTotalPurchase']) {
                globalMoneyObject[yearName]['months'][i]['incomesMonthTotalPurchase'] = 0
            }
            if (!globalMoneyObject[yearName]['months'][i]['expensesMonthTotalPayment']) {
                globalMoneyObject[yearName]['months'][i]['expensesMonthTotalPayment'] = 0
            }
            if (!globalMoneyObject[yearName]['months'][i]['expensesMonthTotalPurchase']) {
                globalMoneyObject[yearName]['months'][i]['expensesMonthTotalPurchase'] = 0
            }
            const incomesMonthPayment = globalMoneyObject[yearName]['months'][i]['incomesMonthTotalPayment']
            const expensesMonthPayment = globalMoneyObject[yearName]['months'][i]['expensesMonthTotalPayment']
            globalMoneyObject[yearName]['months'][i]['balanceMonthPayment'] = Number(Number(incomesMonthPayment - expensesMonthPayment).toFixed(2))
            globalMoneyObject[yearName]['months'][i]['balanceMonthPurchase'] = 0
        }
    }

    globalMoneyObject.yearsArr = yearsArr
    globalMoneyObject.yearsObject = yearsObject
    globalMoneyObject.currency = money['settings']['currencies'][money['settings']['currency']]

    setLocalStorageItem('global-money-object', globalMoneyObject)
}

export const expandCollapseHandler = (id, purpose, setExpandIncome, setExpandExpense) => {
    const i = document.getElementById(id)
    if (i.className === 'fa-solid fa-chevron-down fs-3 opacity-75 p-0') {
        i.className = 'fa-solid fa-chevron-up fs-3 opacity-75 p-0'
        document.querySelector(`#${purpose}-div-date-0`)
        if (purpose === 'income') {
            setExpandIncome(true)
        } else {
            setExpandExpense(true)
        }
    } else {
        i.className = 'fa-solid fa-chevron-down fs-3 opacity-75 p-0'
        if (purpose === 'income') {
            setExpandIncome(false)
        } else {
            setExpandExpense(false)
        }
    }
}

export const getGlobalMoneyObject = () => {
    return getLocalStorageItem('global-money-object')
}

export const getPathAndQueryParams = () => {
    return window.location.pathname + window.location.search
}

export const returnToPage = (page) => {
    const l = objectLang().language.lang
    const history = createBrowserHistory()
    switch (page) {
        case 'MainPage':
            history.push(`/${l}/`)
            // console.log(window.location.href)
            return (<><MainPage/></>)
        default:
            window.location.replace(getPathAndQueryParams())
    }
}

export const readLocalStorage = () => {
    const data = {}
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i)
        data[key] = getLocalStorageItem(key)
    }
    // console.log(data)
}

export const logging = (l, auth, data, deviceId) => {
    auth.login(
        data.superUser,
        data.rootFolder,
        data.avatarLink,
        data.accessToken,
        data.refreshToken,
        data.userId,
        data.nickName,
        data.language,
        data.authenticatedVia,
        deviceId,
        data.email
    )
    window.location.replace(`/${l}/`)
}

export const getCardDetailsFromDOM = () => {
    const name = document.querySelector('#nameCard').value
    const type = document.querySelector('#select-type').value
    const currency = document.querySelector('#select-currency').value
    const date = document.querySelector('#selector-date').value ? document.querySelector('#selector-date').value : 'current-day'
    const isDefault = document.querySelector('#input-default').checked
    return {
        name: name,
        type: type,
        currency: currency,
        date: date,
        isDefault: isDefault,
    }
}

export const oldValues = (lang, data) => {
    let type, date
    if (data.contentType === lang.body.moneyPage.cardTypeCredit) {
        type = 'Credit'
    } else if (data.contentType === lang.body.moneyPage.cardTypeDebit) {
        type = 'Debit'
    } else {
        type = 'Cash'
    }
    if (data.contentDate === lang.body.moneySettingsPage.oneSameDay) {
        date = lang.body.moneySettingsPage.oneSameDay
    } else {
        date = data.contentDate
    }
    return {
        type: type,
        date: date,
        currency: data.contentCurrency
    }
}

export const getFieldDatesForAddUpdateCardBank = (lang, data, isView = true) => {
    let dNone
    if (Number.isNaN(Number(data.contentDate))) {
        dNone = 'd-none'
    } else {
        dNone = ''
    }
    const changeDateHandler = (e) => {
        if (e.target.value !== '0') {
            e.target.classList.remove('is-invalid')
        } else {
            e.target.classList.add('is-invalid')
        }
    }

    setTimeout(() => {
        const selectType = document.querySelector('#select-type')
        const selectorDate = document.createElement('div')
        selectorDate.className = `mt-4 ${dNone}`
        selectorDate.id = 'div-selector-date'
        const labelDate = document.createElement('label')
        labelDate.innerHTML = lang.body.cardBankPage.labelDate
        labelDate.className = 'form-label'
        selectorDate.append(labelDate)
        const formSelect = document.createElement('select')
        formSelect.className = 'form-select is-invalid'
        formSelect.id = 'selector-date'
        formSelect.required = true
        formSelect.onchange = changeDateHandler
        selectorDate.append(formSelect)

        let date
        for (let i = 1; i < 29; i++) {
            const option = document.createElement('option')
            date = i
            option.value = String(date)
            option.innerHTML = String(date)
            if (i === Number(oldValues(lang, data).date)) {
                option.selected = true
                option.value = oldValues(lang, data).date
                option.innerHTML = oldValues(lang, data).date
            }
            formSelect.append(option)
        }

        selectType.insertAdjacentElement('afterend', selectorDate)
    }, 100)
}

export const refreshMoney = async (auth, request) => {
    const l = objectLang().language.lang
    try {
        const data = await request(
            `${host}/api/money/get`,
            'GET',
            null,
            {
                Authorization: getAuthHeader(auth)
            })

        if (data.status === 200) {
            if (JSON.stringify(data['money']) !== JSON.stringify(getGlobalMoneyObject().general)) {
                return await data['money']
            } else {
                return false
            }
        }
        return false

    } catch (e) {
        window.location.replace(`/${l}/`)
    }
}

export const getRandomKey = (numberOfChar = 12) => {
    let result = ''
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ-abcdefghijklmnopqrstuvwxyz0123456789'
    const charactersLength = characters.length
    let counter = 0
    while (counter < numberOfChar) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength))
        counter += 1
    }
    return result
}

export const proxyImage = (url) => {
    if (url && !url.includes('application') && !url.includes('audio') && !url.includes('pdf')) {
        return `${host}/api/proxy-image?url=${encodeURIComponent(url)}`
    } else if (url && (url.includes('pdf') || url.includes('application') || url.includes('audio'))) {
        return getIcon(url, '')
    } else {
        return ''
    }
}

export const loadChildrenGoogleFolders = (documents, parentId, setTree) => {
    const items = documents?.folders || []
    const folders = items
        .filter(i => i.type === "google-folder")
        .map(f => ({
            id: f.id,
            name: f.name,
            children: [],
            loaded: false,
            expanded: false,
            loading: false,
            parentId
        }))

    setTree(prev => {
        const newTree = { ...prev }
        folders.forEach(f => newTree[f.id] = f)
        newTree[parentId] = {
            ...newTree[parentId],
            children: folders.map(f => f.id),
            loaded: true,
            expanded: true,
            loading: false
        }
        return newTree
    })
    return folders
}

export const loadChildrenFolders = (documents, parentId, setTree) => {
    const items = documents?.folders || []

    const folders = items
        .map(f => ({
            id: f._id,
            name: f.name,
            children: [],
            loaded: false,
            expanded: false,
            loading: false,
            parentId
        }))

    setTree(prev => {
        const newTree = { ...prev }
        folders.forEach(f => newTree[f.id] = f)
        newTree[parentId] = {
            ...newTree[parentId],
            children: folders.map(f => f.id),
            loaded: true,
            expanded: true,
            loading: false
        }
        return newTree
    })
    return folders
}

export const isCloudinaryUrl = (url) => {
    try {
        const parsed = new URL(url)
        return parsed.hostname === "res.cloudinary.com"
    } catch {
        return false
    }
}

export const isGoogleDiskPdf = (link) => {
    try {
        if (link['linkContentType'] === 'google-file' && link['thumbUrl'] === config.iconGooglePdfFile) return true
    } catch {
        return false
    }
}

export const isGoogleImage = (item) => {
    return item['mimeType'].startsWith('image/')
}

export const setImagesDataToSlider = (items) => {
    const arr = []
    for (const i in items) {
        const item = items[i]
        if (item.type === 'link') {
            if (isCloudinaryUrl(item['from'])) {
                arr.push({id: item['_id'],
                    name: item['name'],
                    src: item['from'],
                    thumb: item['thumbUrl'],
                })
            }
        }
        if (item.type === 'google-file') {
            if (item['mimeType'].startsWith('image/')) {
                arr.push({id: item['id'],
                    name: item['name'],
                    src: item['linkViewImage'],
                    thumb: item['thumbUrl'],
                })
            }
        }
    }
    setLocalStorageItem(`images-to-slider`, arr)
}

export const isSlider = (url) => {
    try {
        const parsed = new URL(url)
        return parsed.pathname.includes("link/image-slide")
    } catch {
        return false
    }
}

export function getLocalStorageSize() {
    let total = 0
    for (let key in localStorage) {
        if (!localStorage.hasOwnProperty(key)) continue

        const value = localStorage.getItem(key)
        total += key.length + (value ? value.length : 0)
    }
    const sizeMB = (total * 2) / (1024 * 1024)
    console.log("LS Used:", sizeMB.toFixed(2) + ' MB')
    console.log("LS Quota:", (getLocalStorageQuota() / 1024 / 1024).toFixed(2) + ' MB')
}

export function getLocalStorageQuota() {
    let testKey = '__test__'
    let data = '1'

    try {
        // увеличиваем строку пока не упадёт
        while (true) {
            localStorage.setItem(testKey, data)
            data += data
        }
    } catch (e) {
        // ошибка QuotaExceededError — достигли лимита
        return data.length * 2 // ~ байты (UTF-16)
    } finally {
        localStorage.removeItem(testKey)
    }
}

export const shortEmail = (email, visible = 3) => {
    const [name, domain] = email.split("@")
    if (!name || !domain) return email
    if (name.length <= visible) return email
    return `${name.slice(0, visible)}...@${domain}`
}